import { type EntitlementsInfo, entitlementsResolverSchema } from '@inkitt/contracts-common';
import { c } from '../../contract';

export const userRouter = c.router(
  {
    entitlements: {
      summary: 'Get user entitlements',
      method: 'GET',
      path: '/entitlements',
      query: entitlementsResolverSchema,
      responses: {
        200: c.type<EntitlementsInfo>(),
      },
    },
  },
  { pathPrefix: '/user' },
);
